import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  root: {
    width: '100%',
    position: 'relative',
    paddingTop: '100px',
    paddingBottom: '50px',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '1140px'
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '960px'
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '720px'
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '540px'
    }
  },
  termsPaper: {
    height: '400px',
    padding: '30px 5px 30px 30px',
    backgroundColor: 'white',
    borderRadius: '9px'
  },
  termsContent: {
    height: '310px',
    paddingRight: '25px',
    width: '100%',
    overflowY: 'scroll',
    '&#iubenda_policy': {
      '&h1': {
        fontSize: '18px',
        fontWeight: '600'
      },
      '&h2': {
        fontSize: '16px',
        fontWeight: '600',
        margin: '10px 0'
      },
      '&h3': {
        fontSize: '16px',
        fontWeight: '600',
        margin: '10px 0'
      },
      '&h4': {
        fontSize: '14px',
        fontWeight: '600',
        margin: '10px 0'
      },
      '&h5': {
        fontSize: '14px',
        fontWeight: '600',
        margin: '10px 0'
      },
      '&p': {
        fontSize: '14px',
        marginBottom: 0
      },
      '&li': {
        fontSize: '14px',
        marginBottom: 0
      }
    }
  },
  terms: {
    marginBottom: '30px'
  },
  bottomMessage: {
    fontSize: '14px',
    fontWeight: 'bold',
    fontStyle: 'italic',
    marginTop: '20px'
  },
  actionsBar: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '20px 0',
    '& button': {
      marginLeft: '15px'
    }
  }
}))
